import FormField from '../ui/FormField';
import PageCard from '../ui/PageCard';
import SegmentedControl from '../ui/SegmentedControl';
import './Analytics.scss';
import '../ui/FilterBar.scss';

const DEFAULT_OPTIONS = [
    { value: 7, label: '7 дней' },
    { value: 30, label: '30 дней' },
    { value: 90, label: '90 дней' },
];

export default function PeriodToolbar({
    periodDays,
    from = '',
    to = '',
    onPeriodChange,
    onFromChange,
    onToChange,
    showCustomDates = true,
    options = DEFAULT_OPTIONS,
    inCard = true,
    title = 'Период',
}) {
    const hasCustomRange = Boolean(from || to);

    const content = (
        <div className="ui-period-toolbar__row">
            <div className="ui-period-toolbar__presets">
                <SegmentedControl
                    options={options}
                    value={hasCustomRange ? null : periodDays}
                    onChange={onPeriodChange}
                />
            </div>
            {showCustomDates && onFromChange && onToChange && (
                <div className="ui-period-toolbar__dates">
                    <FormField
                        inline
                        label="С"
                        type="date"
                        value={from}
                        onChange={(e) => onFromChange(e.target.value)}
                    />
                    <FormField
                        inline
                        label="По"
                        type="date"
                        value={to}
                        onChange={(e) => onToChange(e.target.value)}
                    />
                </div>
            )}
        </div>
    );

    if (!inCard) {
        return <div className="ui-period-toolbar">{content}</div>;
    }

    return (
        <PageCard className="ui-period-toolbar">
            {title && <p className="ui-period-toolbar__title">{title}</p>}
            {content}
        </PageCard>
    );
}
